import { c as _c } from "react/compiler-runtime";
import { ListStatusIcon } from "@components/common/faro-table/bulk-dialog/content-list/list-status-icon";
import { PALETTE_VARS } from "@styles/palette-vars";
import { MemberListContent } from "@components/common/faro-table/bulk-dialog/content-list/member-list-content";
import { ProjectListContent } from "@components/common/faro-table/bulk-dialog/content-list/project-list-content";
import { TeamListContent } from "@components/common/faro-table/bulk-dialog/content-list/team-list-content";
import { SnapshotListContent } from "@components/common/faro-table/bulk-dialog/content-list/snapshot-list-content";
import { ListItem, NO_TRANSLATE_CLASS } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { withEllipsisTwoLines } from "@styles/common-styles";
/** List item in bulk action dialog  */
export function BulkActionListItem(t0) {
  const $ = _c(25);
  const {
    tableDataType,
    item,
    fallbackLabel,
    note
  } = t0;
  let content = null;
  bb0: switch (tableDataType) {
    case "projects":
      {
        let t1;
        if ($[0] !== item) {
          t1 = ProjectListContent({
            item
          });
          $[0] = item;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        content = t1;
        break bb0;
      }
    case "members":
      {
        let t1;
        if ($[2] !== fallbackLabel || $[3] !== item) {
          t1 = MemberListContent({
            item,
            fallbackLabel
          });
          $[2] = fallbackLabel;
          $[3] = item;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        content = t1;
        break bb0;
      }
    case "teams":
      {
        let t1;
        if ($[5] !== item) {
          t1 = TeamListContent({
            item
          });
          $[5] = item;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        content = t1;
        break bb0;
      }
    case "snapshots":
      {
        let t1;
        if ($[7] !== item) {
          t1 = SnapshotListContent({
            item
          });
          $[7] = item;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        content = t1;
        break bb0;
      }
    default:
  }
  if (!content) {
    return null;
  }
  const t1 = item.status === "not-allowed" ? PALETTE_VARS.Chip.error.background : "none";
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      ml: "12px",
      ...withEllipsisTwoLines,
      maxWidth: "350px"
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1) {
    t3 = {
      px: "0px",
      fontSize: "14px",
      backgroundColor: t1,
      "& .MuiListItemText-root": t2
    };
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alignItems: "center",
      flex: "1 1 auto",
      minWidth: 0
    };
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== content) {
    t5 = <Stack direction="row" className={NO_TRANSLATE_CLASS} sx={t4}>{content}</Stack>;
    $[13] = content;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      alignItems: "center",
      gap: 1,
      flexShrink: 0,
      ml: 1
    };
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== item) {
    t7 = <ListStatusIcon item={item} />;
    $[16] = item;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== note || $[19] !== t7) {
    t8 = <Stack direction="row" sx={t6}>{note}{t7}</Stack>;
    $[18] = note;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t3 || $[22] !== t5 || $[23] !== t8) {
    t9 = <ListItem sx={t3}>{t5}{t8}</ListItem>;
    $[21] = t3;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}